module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_CS-b420341d42a0ca10ce8ad2fe6b301c07.svg";